
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 403 403","width":"19","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M393 198.3L209.8 15.1c-5.5-5.5-14.4-5.5-19.9 0L6.7 198.3l19.9 19.9L199.9 45l112.9 113c0 .4-.2.7-.2 1v211.4H87.1v-141H58.9v155c0 7.8 6.3 14.1 14.1 14.1h253.6c7.8 0 14.1-6.3 14.1-14.1V185.9l32.3 32.3c20-19.9.1 0 20-19.9z","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    